<div class="contains-button">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <div class="check-class" *ngIf="!isViewAll">
    <nz-radio-group [(ngModel)]="objectChoosing.isLogin" (ngModelChange)="
        vhEventMediator.notifyOnConfigChanged({
          _id: this.objectChoosing._id,
          changeActive: true
        })
      ">
      <label nz-radio *ngFor="let item of status" [nzValue]="item.type"><span>{{ item.title | translate }}</span></label>
    </nz-radio-group>
  </div>
  <!-- Config nút đăng nhập -->
  <div class="btn-login-logout-2states">
    <ng-container *ngIf="!isViewAll">
      <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
        <!-- Cấu hình format font name của button -->
        <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
          <div class="container-font">
            <!-- chọn ngôn ngữ đa ngôn ngữ -->
            <div class="field-row mb-3">
              
            </div>
            <div class="config-text" style="width: 100%">
              <!-- Đăng nhập -->
              <ng-container *ngIf="objectChoosing.isLogin">
                <mat-form-field style="width: 100%">
                  <mat-label>{{'noi_dung' | translate}}</mat-label>
                  <textarea matInput
                    [ngModel]="staticdata['content_login_' + functionService.selectedLanguageCode] | vhLanguage : 'content_login' : objectChoosing.component" 
                    (ngModelChange)="staticdata['content_login_' + functionService.selectedLanguageCode] = $event" 
                    (blur)="updateContent('content_login')"></textarea>
                </mat-form-field>

                <!-- Nếu nội dung không có thì phải có nhãn -->
                <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
                *ngIf="!staticdata['content_login_' + functionService.selectedLanguageCode]?.trim()">
                  <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
                  <textarea matInput
                    [ngModel]="staticdata.accessibility?.['aria_label_login_' + functionService.selectedLanguageCode]"
                    (ngModelChange)="staticdata.accessibility['aria_label_login_' + functionService.selectedLanguageCode] = $event"
                    (blur)="updateContent('aria_label_login', true);"></textarea>
                </mat-form-field>
              </ng-container>

              <ng-container *ngIf="!objectChoosing.isLogin">
                <mat-form-field style="width: 100%">
                  <mat-label>{{'noi_dung' | translate}}</mat-label>
                  <textarea matInput
                    [ngModel]="staticdata['content_logout_' + functionService.selectedLanguageCode] | vhLanguage : 'content_logout' : objectChoosing.component" 
                    (ngModelChange)="staticdata['content_logout_' + functionService.selectedLanguageCode] = $event" 
                    (blur)="updateContent('content_logout')"></textarea>
                </mat-form-field>
  
                <!-- Nếu nội dung không có thì phải có nhãn -->
                <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
                *ngIf="!staticdata['content_logout_' + functionService.selectedLanguageCode]?.trim()">
                  <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
                  <textarea matInput
                    [ngModel]="staticdata.accessibility?.['aria_label_logout_' + functionService.selectedLanguageCode]"
                    (ngModelChange)="staticdata.accessibility['aria_label_logout_' + functionService.selectedLanguageCode] = $event"
                    (blur)="updateContent('aria_label_logout', true);"></textarea>
                </mat-form-field>
              </ng-container>
            </div>
            <div class="config-font-size">
              <div class="field-row-font" style="width: 65%">
                <mat-form-field style="width: 100%">
                  <mat-label>Font</mat-label>
                  <mat-select [(ngModel)]="
                      class[
                        objectChoosing.isLogin
                          ? '+btn-login-logout-2states__content'
                          : '-btn-login-logout-2states__content'
                      ]['font-family']
                    " (ngModelChange)="updateClass()" [(value)]="
                      class[
                        objectChoosing.isLogin
                          ? '+btn-login-logout-2states__content'
                          : '-btn-login-logout-2states__content'
                      ]['font-family']
                    ">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{ font.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="field-row-size" style="width: 35%">
                <mat-form-field style="width: 100%">
                  <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                  <input matInput type="number" [ngModel]="
                      class[
                        objectChoosing.isLogin
                          ? '+btn-login-logout-2states__content'
                          : '-btn-login-logout-2states__content'
                      ]['font-size'] | vhnumber
                    " (ngModelChange)="
                      class[
                        objectChoosing.isLogin
                          ? '+btn-login-logout-2states__content'
                          : '-btn-login-logout-2states__content'
                      ]['font-size'] = $event + 'px'
                    " />
                </mat-form-field>
              </div>
            </div>
            <div class="config-font">
              <p class="title-font">{{'kieu_chu' | translate}}</p>
              <div class="field-row">
                <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                    class[
                      objectChoosing.isLogin
                        ? '+btn-login-logout-2states__content'
                        : '-btn-login-logout-2states__content'
                    ]['font-weight'] == 'bold'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class[
                      objectChoosing.isLogin
                        ? '+btn-login-logout-2states__content'
                        : '-btn-login-logout-2states__content'
                    ]['font-weight'] =
                      class[
                        objectChoosing.isLogin
                          ? '+btn-login-logout-2states__content'
                          : '-btn-login-logout-2states__content'
                      ]['font-weight'] == 'bold'
                        ? '500'
                        : 'bold';
                    updateClass()
                  ">
                  <span style="font-weight: 600">B</span>
                </button>
                <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                    class[
                      objectChoosing.isLogin
                        ? '+btn-login-logout-2states__content'
                        : '-btn-login-logout-2states__content'
                    ]['font-style'] == 'italic'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class[
                      objectChoosing.isLogin
                        ? '+btn-login-logout-2states__content'
                        : '-btn-login-logout-2states__content'
                    ]['font-style'] =
                      class[
                        objectChoosing.isLogin
                          ? '+btn-login-logout-2states__content'
                          : '-btn-login-logout-2states__content'
                      ]['font-style'] == 'normal'
                        ? 'italic'
                        : 'normal';
                    updateClass()
                  ">
                  <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                    class[
                      objectChoosing.isLogin
                        ? '+btn-login-logout-2states__content'
                        : '-btn-login-logout-2states__content'
                    ]['text-decoration'] == 'underline'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class[
                      objectChoosing.isLogin
                        ? '+btn-login-logout-2states__content'
                        : '-btn-login-logout-2states__content'
                    ]['text-decoration'] =
                      class[
                        objectChoosing.isLogin
                          ? '+btn-login-logout-2states__content'
                          : '-btn-login-logout-2states__content'
                      ]['text-decoration'] == 'none'
                        ? 'underline'
                        : 'none';
                    updateClass()
                  ">
                  <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                    class[
                      objectChoosing.isLogin
                        ? '+btn-login-logout-2states__content'
                        : '-btn-login-logout-2states__content'
                    ]['text-transform'] == 'uppercase'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class[
                      objectChoosing.isLogin
                        ? '+btn-login-logout-2states__content'
                        : '-btn-login-logout-2states__content'
                    ]['text-transform'] =
                      class[
                        objectChoosing.isLogin
                          ? '+btn-login-logout-2states__content'
                          : '-btn-login-logout-2states__content'
                      ]['text-transform'] == 'none'
                        ? 'uppercase'
                        : 'none';
                    updateClass()
                  ">
                  <span>AB</span>
                </button>
                <div>
                  <input class="color" type="button"  [cpOKButton]="true" [(colorPicker)]="
                      class[
                        objectChoosing.isLogin
                          ? '+btn-login-logout-2states__content'
                          : '-btn-login-logout-2states__content'
                      ].color
                    " type="button" [style.background]="
                      class[
                        objectChoosing.isLogin
                          ? '+btn-login-logout-2states__content'
                          : '-btn-login-logout-2states__content'
                      ].color
                    " (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                </div>
              </div>
            </div>
            <div class="font-adjusting">
              <div class="row-spacing">
                <span class="title">{{'gian_cach_chu' | translate}}</span>
                <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                    class[
                      objectChoosing.isLogin
                        ? '+btn-login-logout-2states__content'
                        : '-btn-login-logout-2states__content'
                    ]['letter-spacing'] | vhnumber
                  " (nzBlur)="updateClass()" (ngModelChange)="
                    class[
                      objectChoosing.isLogin
                        ? '+btn-login-logout-2states__content'
                        : '-btn-login-logout-2states__content'
                    ]['letter-spacing'] = $event + 'px'
                  "></nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="
                  class[
                    objectChoosing.isLogin
                      ? '+btn-login-logout-2states__content'
                      : '-btn-login-logout-2states__content'
                  ]['letter-spacing'] | vhnumber
                " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                  class[
                    objectChoosing.isLogin
                      ? '+btn-login-logout-2states__content'
                      : '-btn-login-logout-2states__content'
                  ]['letter-spacing'] = $event + 'px'
                "></nz-slider>
            </div>
            <div class="font-adjusting">
              <div class="row-spacing">
                <span class="title">{{ 'khoang_cach_dong' | translate }}</span>
                <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1" [(ngModel)]="
                    class[
                      objectChoosing.isLogin
                        ? '+btn-login-logout-2states__content'
                        : '-btn-login-logout-2states__content'
                    ]['line-height']
                  " (nzBlur)="updateClass()"></nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1" [(ngModel)]="
                  class[
                    objectChoosing.isLogin
                      ? '+btn-login-logout-2states__content'
                      : '-btn-login-logout-2states__content'
                  ]['line-height']
                " (nzOnAfterChange)="updateClass()"></nz-slider>
            </div>
          </div>
        </li>
        <!-- Cấu hình màu nền của button -->
        <li nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
          <div class="container-color">
            <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
              [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip
              [disabled]="
                config[
                  objectChoosing.isLogin
                    ? '+background-color'
                    : '-background-color'
                ].gradient_check
              "></button>
          </div>
          <div class="color-pick">
            <span class="title w-50">{{'chon_mau' | translate}}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="
                class[
                  objectChoosing.isLogin
                    ? '+btn-login-logout-2states'
                    : '-btn-login-logout-2states'
                ]['background-color']
              " [style.background]="
                class[
                  objectChoosing.isLogin
                    ? '+btn-login-logout-2states'
                    : '-btn-login-logout-2states'
                ]['background-color']
              " [disabled]="
                config[
                  objectChoosing.isLogin
                    ? '+background-color'
                    : '-background-color'
                ].gradient_check
              " (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
          </div>
          <div class="mr-2 mb-4 mt-4 view-more" style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 7px;
            ">
            <p class="discover_text" (click)="openViewAll(styles_field[3])"
              style="cursor: pointer; text-align: left; margin: 0">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </div>
          <!-- Mở popup so sánh màu tương phản -->
          <button *ngIf="staticdata['content_' + (objectChoosing.isLogin ? 'login_' : 'logout_') + functionService.selectedLanguageCode]"
          nz-row (click)="openColorContrast()" nz-tooltip
          [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
          style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
            {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
          </button>
        </li>
        <!-- Cấu hình đổ bóng -->
        <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
          <div class="item-shadow">
            <p class="m-0 title">{{'ap_dung' | translate}}</p>
            <nz-switch [(ngModel)]="
                config[objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'][
                  'shadow_check'
                ]
              " (ngModelChange)="onChangeShadow(); updateObject()"></nz-switch>
          </div>
          <div class="shadow-direction">
            <div class="dir-x">
              <div class="row-x">
                <span>{{'truc_x' | translate}}</span>
                <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                  [(ngModel)]="
                    config[
                      objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                    ]['offset_x']
                  " (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()" [disabled]="
                    !config[
                      objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                    ]['shadow_check']
                  "></nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="
                      config[
                        objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                      ]['offset_x']
                    " (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()" [nzDisabled]="
                      !config[
                        objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                      ]['shadow_check']
                    "></nz-slider>
                </nz-col>
              </nz-row>
            </div>
            <div class="dir-y">
              <div class="row-x">
                <span>{{'truc_y' | translate}}</span>
                <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                  [(ngModel)]="
                    config[
                      objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                    ]['offset_y']
                  " (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()" [disabled]="
                    !config[
                      objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                    ]['shadow_check']
                  "></nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="
                      config[
                        objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                      ]['offset_y']
                    " (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()" [nzDisabled]="
                      !config[
                        objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                      ]['shadow_check']
                    "></nz-slider>
                </nz-col>
              </nz-row>
            </div>
            <div class="dir-b">
              <div class="row-b">
                <span style="line-height: 1.5">{{'lam_mo' | translate}}</span>
                <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{ width: '40%' }" [(ngModel)]="
                    config[
                      objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                    ]['blur_radius']
                  " (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()" [disabled]="
                    !config[
                      objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                    ]['shadow_check']
                  "></nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="
                      config[
                        objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                      ]['blur_radius']
                    " (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()" [nzDisabled]="
                      !config[
                        objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'
                      ]['shadow_check']
                    "></nz-slider>
                </nz-col>
              </nz-row>
            </div>
          </div>
          <div class="item-shadow">
            <p class="m-0 title w-50">{{'mau_bong' | translate}}</p>
            <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="
                config[objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'][
                  'shadow_color'
                ]
              " [style.background]="
                config[objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'][
                  'shadow_color'
                ]
              " (colorPickerClose)="onChangeShadow()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
              [disabled]="
                !config[objectChoosing.isLogin ? '+box-shadow' : '-box-shadow'][
                  'shadow_check'
                ]
              " />
          </div>
        </li>
        <!-- Cấu hình hình dạng viền -->
        <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
          <app-borders-config [device]="device" [class]="class" [borderClass]="
              objectChoosing.isLogin
                ? class['+btn-login-logout-2states']
                : class['-btn-login-logout-2states']
            " [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
          </app-borders-config>
          <!-- Nút mở rộng -->
          <div class="item-border my-3" style="float: right">
            <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </div>
        </li>
        <!-- Cấu hình biểu tượng -->
        <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
          <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="
              objectChoosing.isLogin
                ? class['+btn-login-logout-2states']
                : class['-btn-login-logout-2states']
            " [fontSizeIconClass]="
              objectChoosing.isLogin
                ? class['+btn-login-logout-2states__content--icon']
                : class['-btn-login-logout-2states__content--icon']
            " [symbolConfig]="
              objectChoosing.isLogin
                ? config['+flex-direction']
                : config['-flex-direction']
            " [objectChoosing]="objectChoosing">
          </app-symbol-config>
        </li>
        <!-- Cấu hình hiệu ứng -->
        <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
          <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
            [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config"
            [staticdata]="staticdata" [cursorClass]="class['button']" [effect_hover]="effect_hover"
            [customize]="customize" [type]="'object'" [effectFileUsing]="'button'">
          </app-choose-animations-config>
          <!-- Cấu hình thêm liên kết -->
        </li>

        <li nz-submenu nzTitle="{{'lien_ket' | translate}}" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')"
          *ngIf="objectChoosing.isLogin">
          <app-link-page-config  [staticdata]="staticdata" [id_object]="objectChoosing._id"></app-link-page-config>
         
        </li>
        <li nz-submenu nzTitle="{{'cau_hinh_thong_bao' | translate}}" [(nzOpen)]="openMap.menu11" (nzOpenChange)="openHandler('menu11')">
          <ng-template #notificationBlock let-dataKey="dataKey" let-configKey="configKey" let-label="label">
            <div class="config-text" style="width: 100%">
              <mat-form-field style="width: 100%">
                <mat-label> {{label | translate}}</mat-label>
                <textarea matInput
                  [ngModel]="staticdata[dataKey + '_' + functionService.selectedLanguageCode]"
                  (ngModelChange)="staticdata[dataKey + '_' + functionService.selectedLanguageCode] = $event"
                  (blur)="updateContent(dataKey)"></textarea>
              </mat-form-field>
          
              <div style="display:flex; justify-content:space-between; align-items:center">
                <span class="w-50" style="line-height:1.2;">{{ 'thoi_gian_hien_thong_bao' | translate }}</span>
                <nz-input-number
                  [nzMin]="2000" [nzMax]="10000" [nzStep]="100"
                  [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                  [ngModel]="config.duration_noti?.[configKey] | vhnumber"
                  (ngModelChange)="config.duration_noti[configKey] = $event"
                  (nzBlur)="updateConfig()" class="w-50">
                </nz-input-number>
              </div>
              <hr />
            </div>
          </ng-template>
  
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_mail_required',
            configKey: 'mail_required', label: 'bat_buoc_nhap_email'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_pass_required',
            configKey: 'pass_required', label: 'bat_buoc_nhap_mat_khau'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_login_success',
            configKey: 'login_success', label: 'dang_nhap_thanh_cong'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_logout_success',
            configKey: 'logout_success', label: 'dang_xuat_thanh_cong'
          }"></ng-container>
          
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_email_existed',
            configKey: 'email_existed', label: 'email_khong_ton_tai'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_auth',
            configKey: 'auth', label: 'xac_thuc_tai_khoan'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_reset_pass',
            configKey: 'reset_pass', label: 'reset_mat_khau'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_incorrect_pass',
            configKey: 'incorrect_pass', label: 'mat_khau_khong_dung'
          }"></ng-container>
        </li>
      </ul>
    </ng-container>
    <!-- Xem chi tiết cấu hình object -->
    <div class="view-more" *ngIf="isViewAll">
      <!-- Cấu hình chi tiết viền -->
      <div class="view_more-border" *ngIf="currentViewAll.index == 2">
        <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="
            objectChoosing.isLogin
              ? class['+btn-login-logout-2states']
              : class['-btn-login-logout-2states']
          " [id_object]="objectChoosing._id">
        </app-borders-radius-config>
      </div>

      <!-- Cấu hình chi tiết hiệu ứng -->
      <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
         <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
          [device]="device"></app-animations-config>
      </div>
      <!-- Cấu hình chi tiết màu gradient  -->
      <div class="container-gradient" *ngIf="currentViewAll.index == 4">
        <div class="title-head">
          <p class="text-fill">{{'phoi_mau' | translate}}</p>
          <label nz-checkbox [(ngModel)]="
              config[
                objectChoosing.isLogin
                  ? '+background-color'
                  : '-background-color'
              ].gradient_check
            " (ngModelChange)="updateBackgroundRgb()"></label>
        </div>
        <div class="list-gradient">
          <button class="btn-gradient" *ngFor="
              let bgGradient of config[
                objectChoosing.isLogin
                  ? '+background-color'
                  : '-background-color'
              ]['gradient_arr'];
              let i = index
            " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }" [disabled]="
              !config[
                objectChoosing.isLogin
                  ? '+background-color'
                  : '-background-color'
              ].gradient_check
            ">
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{ 'them_mau' | translate }}</p>
        <div class="container_add-gradient">
          <input class="input-color" type="button"  [cpOKButton]="true" [(colorPicker)]="
              class[
                objectChoosing.isLogin
                  ? '+btn-login-logout-2states'
                  : '-btn-login-logout-2states'
              ]['background-color']
            " type="button" [disabled]="
              !config[
                objectChoosing.isLogin
                  ? '+background-color'
                  : '-background-color'
              ].gradient_check
            " [style.background]="
              class[
                objectChoosing.isLogin
                  ? '+btn-login-logout-2states'
                  : '-btn-login-logout-2states'
              ]['background-color']
            " (colorPickerClose)="addGradient($event)" />
        </div>
        <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
        <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip [nzTooltipTitle]="type.name | translate"
          (click)="chooseOption(type, $event)" [disabled]="
            !config[objectChoosing.isLogin ? '+background-color' : '-background-color'].gradient_check
          " [style.background]="
            'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'
          " [class.active]="config[(objectChoosing.isLogin ? '+' : '-') + 'background-color'].gradient_direction === type.direction"]></button>
      </div>
    </div>
  </div>
  <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed" *ngIf="!isViewAll">
    <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
      <div class="button-size">
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </div>
    </li>
    
    
  </ul>
</div>